const orbit = document.getElementById('whats-the-box-wrap');
const items = orbit.querySelectorAll('.whats-the-box-image');

function placeOrbit() {
  if (!orbit || items.length === 0) return;
  
  requestAnimationFrame(() => {
    const cx = orbit.clientWidth / 2;
    const cy = orbit.clientHeight / 2;
    // Збільшений радіус для екранів 1920+
    const baseRadius = window.innerWidth >= 1920 ? orbit.clientWidth * 0.42 : orbit.clientWidth * 0.42;
    
    // console.log('placeOrbit:', { cx, cy, baseRadius, orbitWidth: orbit.clientWidth, orbitHeight: orbit.clientHeight });

    // Separate title from other items
    const titleItem = Array.from(items).find(item => item.classList.contains('is-title'));
    const otherItems = Array.from(items).filter(item => !item.classList.contains('is-title'));

    // Position title at the top center (horizontally centered above the center image)
    if (titleItem) {
      // Use left: 50% and transform for centering
      titleItem.style.position = 'absolute';
      titleItem.style.left = '50%';
      titleItem.style.transform = 'translateX(-50%)';
      titleItem.style.top = '0px';
    }

    // Position other items evenly around the circle
    // Title is at -90 degrees (top), we exclude 90 degrees around it (-135 to -45)
    // First item should be lower than title, starting just after exclusion zone
    // Last item should be at same vertical level as first
    const radius = baseRadius;
    const numItems = otherItems.length;
    
    // First item angle: lower than title, just after exclusion zone (-45)
    // Set to -35 degrees to be clearly lower and avoid overlap
    const firstItemAngle = -35;
    // Last item angle: symmetric to first for same Y coordinate
    // sin(θ) = sin(180 - θ), so if first is at -35, last should be at 215
    const lastItemAngle = 180 - firstItemAngle; // 215 degrees
    
    // Calculate total angle span (going clockwise from first to last)
    // From -20 to 200: we go -20 -> 0 -> 180 -> 200 = 220 degrees
    // But we need to account for the title exclusion zone (-135 to -45)
    // So we'll distribute items, but skip angles in the exclusion zone
    
    otherItems.forEach((item, i) => {
      // Reset position temporarily to measure
      item.style.position = 'relative';
      item.style.left = 'auto';
      item.style.top = 'auto';
      
      // Force reflow to get accurate dimensions
      item.offsetHeight;
      
      const width = item.offsetWidth;
      const height = item.offsetHeight;
      
      // Restore absolute positioning
      item.style.position = 'absolute';
      
      // Calculate angle for this item
      let angle;
      if (numItems === 1) {
        angle = firstItemAngle;
      } else {
        // Distribute from firstItemAngle to lastItemAngle
        // Total span: from -35 to 215 = 250 degrees
        let totalSpan = lastItemAngle - firstItemAngle;
        if (totalSpan < 0) totalSpan += 360; // Handle wrapping
        
        const angleStep = totalSpan / (numItems - 1);
        angle = firstItemAngle + (angleStep * i);
        
        // Normalize to 0-360 range
        while (angle < 0) angle += 360;
        while (angle >= 360) angle -= 360;
      }
      
      const rad = angle * Math.PI / 180;
      
      const x = cx + Math.cos(rad) * radius;
      const y = cy + Math.sin(rad) * radius;
      
      item.style.left = `${x - width / 2}px`;
      item.style.top = `${y - height / 2}px`;
    });
  });
}

// Initialize when DOM is ready and images are loaded
function initPlaceOrbit() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('load', () => setTimeout(placeOrbit, 100));
      setTimeout(placeOrbit, 200);
    });
  } else {
    window.addEventListener('load', () => setTimeout(placeOrbit, 100));
    setTimeout(placeOrbit, 200);
  }
}

initPlaceOrbit();
window.addEventListener('resize', placeOrbit);